module.exports = __webpack_public_path__ + "static/media/img.0daca82f.jpeg";